import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
    FaTachometerAlt, 
    FaUsers, 
    FaBoxOpen, 
    FaShoppingCart, 
    FaUserCheck, 
    FaUserShield,
    FaComments,
    FaChartLine,
    FaClipboardList,
    FaCog,
    FaBoxes,
    FaExclamationTriangle,
    FaTags
} from 'react-icons/fa';
import logo from '../../assets/logo.png'; // Assuming logo is here

const AdminSidebar = () => {
  return (
    <aside className="admin-sidebar">
      <div className="admin-sidebar-header">
        <img src={logo} alt="UniTrade Logo" className="logo-img" />
        <span className="logo-text">UniTrade</span>
      </div>
      <nav className="admin-nav">
        <ul className="admin-nav-list">
          <li>
            <NavLink to="/admin" end className="admin-nav-link">
              <FaTachometerAlt />
              <span>Dashboard</span>
            </NavLink>
          </li>
          {/* User Management */}
          <li className="nav-section">
            <span className="nav-section-title">User Management</span>
            <ul className="nav-submenu">
              <li>
                <NavLink to="/admin/users" className="admin-nav-link">
                  <FaUsers />
                  <span>All Users</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/seller-verification" className="admin-nav-link">
                  <FaUserCheck />
                  <span>Verify Sellers</span>
                </NavLink>
              </li>
            </ul>
          </li>

          {/* Product Management */}
          <li className="nav-section">
            <span className="nav-section-title">Product Management</span>
            <ul className="nav-submenu">
              <li>
                <NavLink to="/admin/products" className="admin-nav-link">
                  <FaBoxOpen />
                  <span>All Products</span>
                </NavLink>
              </li>
            </ul>
          </li>

          {/* Orders & Transactions */}
          <li className="nav-section">
            <span className="nav-section-title">Orders & Transactions</span>
            <ul className="nav-submenu">
              <li>
                <NavLink to="/admin/orders" className="admin-nav-link">
                  <FaShoppingCart />
                  <span>All Orders</span>
                </NavLink>
              </li>
            </ul>
          </li>

          {/* Reports & Analytics */}
          <li className="nav-section">
            <span className="nav-section-title">Reports & Analytics</span>
            <ul className="nav-submenu">
              <li>
                <NavLink to="/admin/sellers" className="admin-nav-link">
                  <FaUsers />
                  <span>Professional Sellers</span>
                </NavLink>
              </li>
            </ul>
          </li>

          {/* Settings */}
          <li className="nav-section">
            <span className="nav-section-title">Settings</span>
            <ul className="nav-submenu">
              <li>
                <NavLink to="/admin/admin-management" className="admin-nav-link">
                  <FaUserShield />
                  <span>Admin Management</span>
                </NavLink>
              </li>
            </ul>
          </li>

          {/* Admin Tools */}
          <li className="nav-section">
            <span className="nav-section-title">Admin Tools</span>
            <ul className="nav-submenu">
              <li>
                <NavLink to="/admin/chat" className="admin-nav-link">
                  <FaComments />
                  <span>Live Chat Support</span>
                </NavLink>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default AdminSidebar;